import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-credit-limit',
  templateUrl: './credit-limit.component.html',
  styleUrls: ['./credit-limit.component.scss'],
})
export class CreditLimitComponent implements OnInit {
  
  creditLimitModal_en:string ='/en/portal/credit-facility/buyandget-credit-facility-learn-more.jsp';
  creditLimitModal_ar:string ='/ar/portal/credit-facility/buyandget-credit-facility-learn-more.jsp';
  currentLanguage: string;
  CMS_URL: string;
  constructor(
    private SS: SubjectService,
    private modalController: ModalController,
    private UTS: UtilitiesService
  ) {
    this.currentLanguage = this.UTS.getLocaleLanguage();
    if(this.currentLanguage == 'en'){
      this.CMS_URL = this.creditLimitModal_en;
    }
    else{
      this.CMS_URL = this.creditLimitModal_ar;
    }
  }

  ngOnInit() {}

  cancel() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
